<template>
  <content-loader
    :height="600"
    :width="700"
    :speed="2"
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
  >
    <rect x="71" y="20" rx="0" ry="0" width="88.51" height="86.87" />
    <rect x="257" y="38" rx="0" ry="0" width="0" height="0" />
    <rect x="169.02" y="20" rx="0" ry="0" width="88.51" height="86.87" />
    <rect x="265.39" y="20" rx="0" ry="0" width="88.51" height="86.87" />
    <rect x="361.78" y="20" rx="0" ry="0" width="88.51" height="86.87" />
    <rect x="72.64" y="114.75" rx="0" ry="0" width="88.51" height="86.87" />
    <rect x="169.02" y="114.75" rx="0" ry="0" width="88.51" height="86.87" />
    <rect x="265.39" y="114.75" rx="0" ry="0" width="88.51" height="86.87" />
    <rect x="361.78" y="114.75" rx="0" ry="0" width="88.51" height="86.87" />
    <rect x="72.64" y="207.86" rx="0" ry="0" width="88.51" height="86.87" />
    <rect x="169.02" y="207.86" rx="0" ry="0" width="88.51" height="86.87" />
    <rect x="265.39" y="207.86" rx="0" ry="0" width="88.51" height="86.87" />
    <rect x="361.78" y="207.86" rx="0" ry="0" width="88.51" height="86.87" />
  </content-loader>
</template>
<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'AnalyticsHeatMapLoader',
  conponents: {
    ContentLoader,
  },
};
</script>



// WEBPACK FOOTER //
// AnalyticsHeatMapLoader.vue?b1ea4b56